import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {readCart, writeCart} from "../../modules/checkoutHelpers";
import {ProductsData} from "../../data/productsData";
import FrequencyToggle from "../../components/checkout/checkoutFlow/frequencyToggle";

export default function OrderSummaryComponent(props) {

    const [cartData, setCartData] = useState(null)
    const [orderSummaryData, setOrderSummaryData] = useState(null)
    const [isMonthlyFrequency, setIsMonthlyFrequency] = useState(null)

    useEffect(() => {
        if (props.cartData) {
            setCartData(props.cartData);
        } else {
            // Fetches from local storage
            readCart((currentCartData) => {
                setCartData(currentCartData);
                setIsMonthlyFrequency(Boolean(currentCartData.isMonthlyFrequency))
            })
        }
    }, [props.cartData]);

    useEffect(() => {
        // Update the orderSummaryData whenever cartData is updated
        if (Boolean(cartData && cartData.productLineItems)) {
            parseCartData(isMonthlyFrequency !== null ? (isMonthlyFrequency ? "monthly" : "annually") : null)
        } else {
            return
        }
    }, [cartData, isMonthlyFrequency]);



    function renderDesktopOrderSummary() {
        if (!orderSummaryData) return null;

        return (
            <div className="sticky">
                <h2 id="summary-heading" className="text-xl text-gray-900">
                    Order summary
                </h2>
                {
                    !Boolean(props.hideToggleFrequency) &&
                    <div className="flex items-center justify-center">
                        <FrequencyToggle isMonthly={isMonthlyFrequency} onChange={() => {
                            const newValue = Boolean(!isMonthlyFrequency)
                            setIsMonthlyFrequency(newValue)

                            // Updates the cart
                            readCart((currentCartData) => {
                                const newCartData = {
                                    ...currentCartData,
                                    isMonthlyFrequency: newValue,
                                }

                                writeCart(newCartData)
                            })
                        }}/>
                    </div>
                }

                <dl className="mt-6 space-y-4">
                    {
                        orderSummaryData.lineItems?.map((item, index) => (
                            <div className="flex items-center justify-between">
                                <dt className="text-sm text-gray-600">
                                    <div className="font-semibold text-gray-600">
                                        {item.title}
                                    </div>
                                    <div>
                                        {/*{item.subtitle}*/}
                                        1 Users, All Apps
                                    </div>
                                </dt>
                                <dd className="text-sm font-medium text-gray-600">{isMonthlyFrequency ? item.monthlyPrice : item.annualPriceByMonth}</dd>
                            </div>
                        ))
                    }

                    {/* Sales tax */}
                    {/*<div className="flex items-center justify-between border-t border-gray-200 pt-4">*/}
                    {/*    <dt className="flex text-sm text-gray-600">*/}
                    {/*        <span>Tax estimate</span>*/}
                    {/*        <a href="#" className="ml-2 shrink-0 text-gray-400 hover:text-gray-500">*/}
                    {/*            <span className="sr-only">Learn more about how tax is calculated</span>*/}
                    {/*            /!*<QuestionMarkCircleIcon aria-hidden="true" className="size-5"/>*!/*/}
                    {/*        </a>*/}
                    {/*    </dt>*/}
                    {/*    <dd className="text-sm font-medium text-gray-900">$8.32</dd>*/}
                    {/*</div>*/}

                    <div className="flex items-center justify-between border-t border-gray-200 pt-4" style={{
                        borderTop: "1px dotted"
                    }}>
                        <dt className="text-base font-medium text-gray-900">Total /
                            month {isMonthlyFrequency ? "" : "(*)"}</dt>
                        <dd className="text-base font-medium text-gray-900">${isMonthlyFrequency ? orderSummaryData.subtotal : orderSummaryData.subtotal / 12}</dd>
                    </div>
                </dl>
                {
                    !Boolean(isMonthlyFrequency) &&
                    <div className="text-sm text-gray-600">
                        (*) Billed annually: US$ {orderSummaryData.subtotal}
                    </div>
                }

                <div className="mt-6">
                    <button
                        type="submit"
                        onClick={() => {
                            props.ctaAction()
                        }}
                        className="w-full rounded-md border border-transparent bg-indigo-600 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                    >

                        {props.ctaString || "Continue"}
                    </button>
                </div>
            </div>
        );
    }


    function renderMobileOrderSummary() {
        if (!orderSummaryData) return null;

        return (
            <div className="relative sm:hidden bg-white shadow-md rounded-xl p-5 border border-gray-100">
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-semibold text-gray-900 mb-1">
                        Order summary
                    </h2>

                    {!props.hideToggleFrequency && (
                        <FrequencyToggle
                            isMonthly={isMonthlyFrequency}
                            onChange={() => {
                                const newValue = Boolean(!isMonthlyFrequency)
                                setIsMonthlyFrequency(newValue)

                                // Updates the cart
                                readCart((currentCartData) => {
                                    const newCartData = {
                                        ...currentCartData,
                                        isMonthlyFrequency: newValue,
                                    }

                                    writeCart(newCartData)
                                })
                            }}
                        />
                    )}
                </div>


                <dl className="space-y-6">
                    {orderSummaryData.lineItems?.map((item, index) => (
                        <div
                            key={index}
                            className="flex flex-row items-center justify-between"
                        >
                            <div>
                                <dt className="text-md font-medium text-gray-900">
                                    {item.title}
                                </dt>
                                <dd className="text-sm text-gray-500">{item.subtitle}</dd>
                            </div>
                            <dd className="text-base font-bold text-gray-900">
                                {isMonthlyFrequency
                                    ? item.monthlyPrice
                                    : item.annualPriceByMonth}
                            </dd>
                        </div>
                    ))}

                    <div
                        className="border-t border-dashed border-gray-300 pt-4 flex flex-row items-center justify-between">
                        <dt className="text-md font-medium text-gray-900">
                            Total / month {isMonthlyFrequency ? "" : "(*)"}
                        </dt>
                        <dd className="text-lg font-bold text-gray-900">
                            ${isMonthlyFrequency
                            ? orderSummaryData.subtotal
                            : orderSummaryData.subtotal / 12}
                        </dd>
                    </div>
                </dl>

                {!isMonthlyFrequency && (
                    <div className="mt-2 text-xs text-gray-500 ">
                        (*) Billed annually: US$ {orderSummaryData.subtotal}
                    </div>
                )}

                <div className="mt-6">
                    <button
                        type="submit"
                        onClick={props.ctaAction}
                        className="w-full rounded-md bg-indigo-600 px-4 py-3 text-md font-semibold text-white shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                        {props.ctaString || "Continue"}
                    </button>
                </div>
            </div>
        );
    }


    return (
        <>
            {/* Mobile version */}
            <section
                aria-labelledby="summary-heading"
                className="relative rounded-lg bg-gray-50 px-4 py-6 sm:hidden"
            >
                {renderMobileOrderSummary()}
            </section>

            {/* Desktop version */}
            <section
                aria-labelledby="summary-heading"
                className="relative mt-16 rounded-lg bg-gray-50 px-4 py-6 hidden sm:block lg:col-span-5 lg:mt-0 lg:p-8"
            >
                {renderDesktopOrderSummary()}
            </section>
        </>
    );


    function parseCartData(frequency = null) {
        const productLineItems = cartData?.productLineItems || []
        const frequencyRate = frequency !== null ? frequency : cartData?.frequency || "month"

        // Updates the subtotal
        let tempSubtotal = 0
        let tempLineItems = []
        for (const item of productLineItems) {
            let currentProduct = null
            for (const product of ProductsData) {
                if (String(product.id) === String(item.productIndex)) {
                    currentProduct = product
                }
            }
            if(!currentProduct) { continue }
            const currentPrice = frequencyRate === "monthly" ? currentProduct.monthlyPrice : currentProduct.annualPrice
            const priceString = currentPrice.replace(/[$,]/g, '');
            const priceInt = parseInt(priceString, 10)
            tempSubtotal += priceInt
            tempLineItems.push({
                title: currentProduct.name,
                subtitle: currentProduct.subtitle,
                monthlyPrice: currentProduct.monthlyPrice,
                annualPrice: currentProduct.annualPrice,
                annualPriceByMonth: currentProduct.annualPriceByMonth,
            })
        }

        const tempOrderSummaryData = {
            frequency: frequencyRate,
            subtotal: tempSubtotal,
            lineItems: tempLineItems,
        }

        // setIsMonthlyFrequency(Boolean(frequencyRate === "month"))
        setOrderSummaryData(tempOrderSummaryData)
    }
}

OrderSummaryComponent.propTypes = {
    cartData: PropTypes.object,
    onToggleFrequency: PropTypes.func,

    hideToggleFrequency: PropTypes.bool,

    ctaString: PropTypes.string,
    ctaAction: PropTypes.func,
}